import { CheckoutStyles } from "@omni/ui/brand/checkout/checkout.styles";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";
import { Config } from "@/utils/config.utils";
import { CheckoutSteps } from "@/utils/enums";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

type Props = {
    fullWidth?: boolean;
};

const _CheckoutButton = ({ fullWidth }: Props) => {
    const { t } = useGranite();
    const customer = useSelector(CustomerSelectors.getCustomer);
    const cart = useSelector(CartSelectors.getCart);
    const startingCheckout = useSelector(CartSelectors.isStartingCheckout);
    const isLoading = useSelector(CartSelectors.isLoading);
    const dispatch = useThunkDispatch();
    const { matches: isSmall, ready } = useIsBreakpoint("sm");

    const itemHasMessages =
        cart?.items.filter((item) => !!item.messages.length) || [];

    const determineCheckoutStepBasedOnUser = () => {
        dispatch(CartModule.startCheckout()).then((action) => {
            if (action.type === CartModule.APIStatus.SUCCESS) {
                const cart: CartModel = action?.payload;
                if (!cart) {
                    return;
                }

                if (
                    cart.messages.length > 0 ||
                    cart.items.some(
                        (item) =>
                            item.messages !== null && item.messages.length > 0
                    ) ||
                    cart.callToActions.length > 0
                ) {
                    return;
                }

                if (customer?.guest) {
                    location.assign(
                        Config.pages[`checkout-${CheckoutSteps.login}`]
                    );
                } else {
                    location.assign(
                        Config.pages[`checkout-${cart.checkoutStep}`]
                    );
                }
            }
        });
    };

    return (
        <div>
            {cart && cart.items.length > 0 && ready && (
                <Button
                    {...getTagIdFor("checkout-button")}
                    test="checkoutButton"
                    disabled={
                        (cart.callToActions || []).length > 0 ||
                        cart.messages.some((e) => e.type === "ERROR") ||
                        itemHasMessages.length > 0 ||
                        startingCheckout ||
                        isLoading
                    }
                    size={!isSmall ? "md" : "lg"}
                    type="button"
                    color={CheckoutStyles.submitButton?.color || "success"}
                    fullWidth={fullWidth !== undefined ? fullWidth : true}
                    onClick={() => determineCheckoutStepBasedOnUser()}
                >
                    {t("checkout.cart.checkoutButton.label")}
                </Button>
            )}
            <div
                className={cn(
                    "tw:mt-2 tw:text-muted-foreground tw:text-center"
                )}
            >
                <i className="las la-lock pr-1"></i>
                {t("checkout.cart.checkoutButton.securePayment")}
            </div>
        </div>
    );
};

export const CheckoutButton = withBreakpoints(_CheckoutButton);
